import axios from 'axios';

export const HTTP = axios.create({
    baseURL: process.env.ROOT_API, //http://vvg.chat.com/api/v1
    headers: {
      	'Content-Type': 'application/json',
      	'Authorization': window.localStorage.getItem('access_token')
    }
});



// WEBPACK FOOTER //
// ./src/http-common.js